import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { environment } from "../../../environments/environment";
import { ExportInfo, ImportType } from "../models";
import { ImportResponse } from "../models/import-response.model";

@Injectable()
export class ExportImportService {

    exportsImportsUrl = environment.dns + 'api/';

    isShowImportManager = new Subject<boolean>();

    constructor(private http: HttpClient) { }

    exportFile(exportInfo: ExportInfo): Observable<Blob> {
        return this.http.post(this.exportsImportsUrl + "exports", exportInfo, { responseType: 'blob' });
    }

    exportPdf(customerAccountId : number): Observable<Blob> {
        return this.http.get(this.exportsImportsUrl + "exports/pdf?customerAccountId="+customerAccountId, { responseType: 'blob' });
    }

    importFile(importType: ImportType, file: FormData, societyId: number): Observable<ImportResponse[]> {
        if (societyId) {
            return this.http.post<ImportResponse[]>(this.exportsImportsUrl + "imports?importType=" + importType + "&societyId=" + societyId, file);
        } else {
            return this.http.post<ImportResponse[]>(this.exportsImportsUrl + "imports?importType=" + importType, file);
        }
    }

    emitShowImportManager() {
        this.isShowImportManager.next(true);
    }
}